import React, { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import Select from 'react-select';

import { groupService } from '../../_services/group.service';

export default function LocationOption({ defaultValue, handleSelected, textDark = false, disabled = false }) {
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState(defaultValue);

  useEffect(() => {
    setSelected(defaultValue);
  }, [defaultValue]);

  useEffect(() => {
    groupService.getAll()
      .then((response) => {
        setOptions(response);
      });
  }, []);

  if (options.length === 0) {
    return <Spinner animation="border" role="status">
      <span className="sr-only">Loading...</span>
    </Spinner>
  }

  const groupOptions = options.map((group) => {
    return { value: group.id, label: group.name }
  });

  const groupOptionSelected = groupOptions.find((group) => {
    return group.value === selected;
  });

  return <Select
    placeholder='Location'
    isClearable={true}
    options={groupOptions}
    onChange={selected => {
      if (selected) {
        setSelected(selected.value);
        handleSelected(selected.value, selected.label);
      } else {
        setSelected('');
        handleSelected('', '');
      }
    }}
    isDisabled={disabled}
    styles={textDark && {
      singleValue: (styles) => {
        return {
          ...styles, color: 'black',
        };
      },
    }}
    value={groupOptionSelected || ''}
  />
}